import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const missingAccounts: IMcAppType = {
  name: "missingAccounts_SAP",
  path: "/my-account/missing-accounts",
  description: "Find missing accounts",
  navFlow: NavFlow.FOCUS,
  title: "Missing Accounts",
  parent: Tab.MORE,
  conditions: {
    intent: "missingAccounts",
    customerType: CustomerType.sap,
  },
};
